module.exports = __webpack_public_path__ + "img/edit.f212a154.svg";